'use strict';

DoohApps
.directive('onReadJson', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            var fn = $parse(attrs.onReadJson);
            var fn2 = $parse(attrs.onFileChange);

            element.on('change', function (onChangeEvent) {
                var reader = new FileReader();
                fn2(scope, {});
                reader.onload = function (onLoadEvent) {

                    scope.$apply(function () {
                        fn(scope, { $fileContent: onLoadEvent.target.result });
                    });
                };

                var fileType = element.prop('files')[0].type;
                if (fileType == 'application/json' || fileType == '') {
                    var name = element.prop('files')[0].name;
                    if (name.length > 5) {
                        var ext = name.substr(name.length - 5);
                        if (ext == '.json' || ext == '.JSON') reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
                    }

                }

            });
        }
    };
}]);